import { GA4EventName, GA4FeatureCategory, trackAnalyticsEvent } from '@jsmdg/tracking';
import { type DeliveryFormatTrackingLabel } from '../../../types/enums/deliveryFormatTrackingLabel';

async function trackDeliveryFormatClicked(label: DeliveryFormatTrackingLabel): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'ButtonClick',
        label,
        eventData: {
            eventName: GA4EventName.SelectProductVariant,
            feature_category: GA4FeatureCategory.ProductdetailBuybox,
            selected_value: label,
        },
    });
}

export { trackDeliveryFormatClicked };
